export enum devicePlatforms {
  web = 'web',
  android = 'android',
  ios = 'ios',
  mac = 'mac',
}
